function Spinner() {
  return (
    <div className="loadingSpinnerContainer">
        <div className="loadingSpiinner"></div>
    </div>
  )
}

export default Spinner